import { css } from '@emotion/react'
import { eqs, etron, ix, lyriq, mache, modelY } from '../assets/images-client/logos'
import { magnetScore } from '../assets/images/icons'
import {
  facebookColor,
  forumsColor,
  instagramColor,
  linkedin,
  reddittColor,
  threadsColor,
  tiktokColor,
  twitterColor,
  gitHubColor,
  youtubeColor,
  standoutColor,
  forumsColor_standout,
  instagramColor_standout,
  facebookColor_standout,
  tiktokColor_standout,
  gitHubColor_standout,
  youtubeColor_standout,
  linkedin_standout,
  twitterColor_standout,
  reddittColor_standout,
  threadsColor_standout,
} from '../assets/images/icons'

export const isProd = !!window.location.href.match('insightsassistant.mavenmagnet.com')
export const isStaging = !!window.location.href.match('staging-ia.mavenmagnet.com')
export const isLocalHost = !!window.location.href.match('localhost:8080')
export const isReportsPage = !!window.location.href.match('reports')

// export const CONST_API_URL = `${process.env.REACT_APP_API_URL}?payload=yes`
export const CONST_API_NODEJS_URL_PROD = process.env.REACT_APP_API_NODEJS_URL_PROD
export const CONST_API_NODEJS_URL_STAGING = process.env.REACT_APP_API_NODEJS_URL_STAGING
export const CONST_API_NODEJS_URL_LOCAL = process.env.REACT_APP_API_NODEJS_URL_LOCAL
export const CONST_API_NODEJS_URL = (isProd && CONST_API_NODEJS_URL_PROD) || (isStaging && CONST_API_NODEJS_URL_STAGING) || (isLocalHost && CONST_API_NODEJS_URL_LOCAL) || '';

export const CONST_API_URL = `${process.env.REACT_APP_API_URL}`
export const CONST_API_JSON_URL = `${isProd ? process.env.REACT_APP_API_JSON_URL_PROD : process.env.REACT_APP_API_JSON_URL_DEV}`

export const CONST_CLIENT_LOGOS = `${process.env.REACT_APP_IMAGES_URL}/logos` //'assets/images-client/logos/'
export const CONST_VERBATIM_PATH = `${process.env.REACT_APP_VERBATIM_URL}/` //'assets/images-client/logos/'
export const CONST_EXPORT_TO_CSV_NAME = `${process.env.REACT_APP_IMAGES_URL}/csvFileNames.csv` 
export const CONST_APP_VERSION_PATH = `${process.env.REACT_APP_IMAGES_URL}/version.json` 
// export const CONST_CLIENT_LOGOS = 'assets/images-client/logos/'
export const CONST_CLIENT_LOGOS_EXTENSION = '.png'
export const CONST_CLIENT_IMAGES = 'assets/images-client/'

export const FREQUENCY = [
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Biannual', value: 'Biannual' },
  { label: 'Annual', value: 'Annual' },
  { label: 'One-time', value: 'Onetime' },
]

export const LEGEND_TEXT_COLOR_MAP = {
  Positive: '#00B050',
  Neutral: '#E3CC1E',
  Negative: '#EE2534',
  Mixed: '#353535',
  MixedNegative: '#353535',
  SearchKeywords: '#000',
}

export const SELECTED_COLOR = '#095BBD'

export const GRAPH_COLOR_PALLET1 = [
  '#52B8C1',
  '#FB6C8B',
  '#B264DE',
  '#5C83D7',
  '#98AB5D',
  '#44A1AA',
  '#EE5575',
  '#9F53C9',
  '#4870C5',
  '#85974C',
  '#378E96',
  '#D43E5E',
  '#8A3FB4',
  '#3A5FB0',
  '#758640',
  '#2C7980',
  '#BB2D4C',
  '#6B2990',
  '#284C97',
  '#57652C',
  '#216167',
  '#A1213D',
  '#541B75',
  '#1D3D81',
  '#475323',
]

export const GRAPH_COLOR_PALLET2 = {
  0: '#52B8C1',
  1: '#FB6C8B',
  2: '#B264DE',
  3: '#5C83D7',
  4: '#98AB5D',
  5: '#44A1AA',
  6: '#EE5575',
  7: '#9F53C9',
  8: '#4870C5',
  9: '#85974C',
  10: '#378E96',
  11: '#D43E5E',
  12: '#8A3FB4',
  13: '#3A5FB0',
  14: '#758640',
  15: '#2C7980',
  16: '#BB2D4C',
  17: '#6B2990',
  18: '#284C97',
  19: '#57652C',
  20: '#216167',
  21: '#A1213D',
  22: '#541B75',
  23: '#1D3D81',
  24: '#475323',
}

export const GRAPH_COLOR_PALLET3 = [
  '#E0ABFF',
  '#BBE9F8',
  '#FFE1BE',
  // '#F3D9DB',
  '#82C0D3',

  '#069ECE',
  '#FFB876',
  '#FA52D5',
  '#6BDCFF',
  '#F48927',

  '#97727A',
  '#91AFED',
  '#BC6AED',
  '#4E79D2',
  '#D0AD83',
]

export const GRAPH_COLOR_PALLET4 = [
  '#4BABB4',
  '#F25279',
  '#6E94FA',
  '#C26873',
  '#248892',
  '#B82D4D',
  '#5F6104',
  '#4A5508',
  '#747852',
  '#85A207',
  '#F3844D',
  '#97674A',
  '#CE8B08',
  '#A094B4',
  '#C51AA4',
  '#8A6DFF',
  '#3FC086',
  '#77A2A2',
  '#7707AB',
  '#C16BFF',
  '#563B76',
  '#96361B',
  '#976F19',
  '#D0244F',
  '#0094FF',
  '#879168',
  '#0E9CBB',
  '#D35F2B',
  '#9D4BD9',
  '#E894A6',
  '#0F66CB',
  '#ED5915',
  '#858704',
  '#C402A5',
  '#854E5A',
  '#698899',
  '#A57035',
  '#9B8A8A',
  '#068AAA',
  '#B49104',
  '#073393',
  '#333350',
  '#0F7680',
  '#D4512D',
  '#5A1E2B',
  '#9D4B5F',
  '#195449',
  '#BD7D06',
  '#624040',
  '#64948E',
]

export const LEGEND_COLOR_MAP_V2 = {
  Positive: '#00B050',
  Neutral: '#E3CC1E',
  Negative: '#EE2534',
  Mixed: '#7c868f',
  Warning: '#D5732E',
  PaidInteractions: '#CC2D65',
  Interactions: '#A04EB5',
  Association: '#7D7DB8',
  // Mention: "#EEECE2",
  Mention: '#3C96BA',
  NetVibe: '#475467',
  Total: '#095BBD',
  SearchKeywords: '#095BBD',
  WithoutSentiments: '#095BBD',

  Consumers: '#FDC1ED',
  NewsMedia: '#AB8BF1',
  MGPartners: '#B80D92',
}

export const GRAPH_COLOR_PALLET_V2 = [
  '#4e41bc',
  '#6872f5',
  '#349aee',
  '#23b9d1',
  '#c253dd',
  '#f64784',
  '#6e4bd5',
  '#cb6c60',
  '#ff7e16',
  '#f2a436',
  '#e9bd2b',
  '#ea9276',
  '#f76363',
  '#42b7e6',
  '#8b8bc6',
] 

export const GRAPH_COLOR_PALLET_V2_TEXT = [
  '#4333c6',
  '#2734da',
  '#217ecb',
  '#22a0b4',
  '#a04eb5',
  '#cc2d65',
  '#583fb0',
  '#ac4a3e',
  '#e16806',
  '#aa834e',
  '#cb9f0e',
  '#d25647',
  '#c32626',
  '#3c96ba',
  '#7d7db8',
]

export const GRAPH_COLOR_PALLET5 = [
  '#4BABB4',
  '#F25279',
  '#9D4BD9',
  '#B49104',
  '#0F66CB',
  '#85A207',
  '#97674A',
  '#A094B4',
  '#563B76',
  '#073393',

  '#0094FF',
  '#879168',
  '#0E9CBB',
  '#D35F2B',
  '#9D4BD9',
  '#E894A6',
  '#0F66CB',
  '#ED5915',
  '#858704',
  '#C402A5',
  '#854E5A',
  '#698899',
  '#A57035',
  '#9B8A8A',
  '#068AAA',
  '#B49104',
  '#073393',
  '#333350',
  '#0F7680',
  '#D4512D',
  '#5A1E2B',
  '#9D4B5F',
  '#195449',
  '#BD7D06',
  '#624040',
  '#64948E',
]

const GRAPH_COLOR_PALLET4_OBJ = Object.assign({}, GRAPH_COLOR_PALLET4)
export const LEGEND_COLOR_MAP_NEW = {
  ...LEGEND_COLOR_MAP_V2,
  ...GRAPH_COLOR_PALLET4_OBJ,
}

export const LEGEND_COLOR_MAP = {
  ...LEGEND_COLOR_MAP_V2,
  ...GRAPH_COLOR_PALLET2,
}

export const SOCIAL_IMAGE_MAP = {
  forum: forumsColor,
  instagram: instagramColor,
  facebook: facebookColor,
  tiktok: tiktokColor,
  youtube: youtubeColor,
  linkedin: linkedin,
  twitter: twitterColor,
  github: gitHubColor,
  reddit: reddittColor,
  threads: threadsColor,

  forum_standout: forumsColor_standout,
  instagram_standout: instagramColor_standout,
  facebook_standout: facebookColor_standout,
  tiktok_standout: tiktokColor_standout,
  youtube_standout: youtubeColor_standout,
  linkedin_standout: linkedin_standout,
  twitter_standout: twitterColor_standout,
  github_standout: gitHubColor_standout,
  reddit_standout: reddittColor_standout,
  threads_standout: threadsColor_standout,

  standout: standoutColor,
}

export const FACTOR_LEGEND = {
  BrandPerception: '#C6C6F8',
  DesignandComfort: '#F1D794',
  Functional: '#C7D994',
  Funtional: '#FCA2B5',
  Performance: '#96E5EE',
  Social: '#CF92F2',
  legend_1: '#7591CD',
  legend_2: '#A69059',
  legend_3: '#27278B',
}

export const MAGNET_SCORE_IMAGE = {
  CELESTIQ: {
    width: 80,
    hegiht: 15,
    icon: lyriq,
  },
  'e-tron': {
    width: 60,
    hegiht: 15,
    icon: etron,
  },
  EQS: {
    width: 45,
    hegiht: 15,
    icon: eqs,
  },
  iX: {
    width: 25,
    hegiht: 15,
    icon: ix,
  },
  'Mach-E': {
    width: 88,
    hegiht: 15,
    icon: mache,
  },
  'Model Y': {
    width: 78,
    hegiht: 15,
    icon: modelY,
  },
  Start: {
    width: 35,
    hegiht: 33,
    icon: magnetScore,
  },
  'Cadillac CELESTIQ': {
    width: 90,
    hegiht: 15,
  },
  'Bentley Flying Spur': {
    width: 90,
    hegiht: 15,
  },
  'Mercedes Maybach S-Class': {
    width: 95,
    hegiht: 15,
  },
  'Rolls Royce Spectre': {
    width: 60,
    hegiht: 15,
  },
}

export const USER_TYPE = [
  { label: 'Admin', value: 'Admin' },
  { label: 'Member', value: 'Member' },
]

export const INTERNAL_USER_TYPE = [
  { label: 'Analyst', value: 'Analyst' },
  { label: 'Publisher', value: 'Publisher' },
]

export const PERMISSION = [
  { label: 'Enabled', value: 'enabled' },
  { label: 'Disabled', value: 'disabled' },
]

export const EXPORT_PPT = {
  // BrandMagnetScore
  deepDiveDrivers: [
    'SearchDrivers',
    'DriversAndSubBrands',
    'DriversWithoutSentimentsAndSubBrands',
    'DriversAndRatingImpacts',
    'Drivers',
    'DriversWithoutSentiments',
    'DriversAndTriggers',
    'DriversMotivatorsDetractors',
    'DriversAndSubBrandsMotivatorsDetractors',
    'DriversAndTriggersMotivatorsDetractors',
    'DriversAndRatingImpactsMotivatorsDetractors',
  ],
  deepDiveSegments: [
    'BrandImageryMappingGraph',
    'BrandImageryMappingAndProgressionGraph', // 'CompetitiveLandscape'
    'CompetitiveLandscape',
    'CompetitiveLandscapeBrandImagery', // Landscape Both Types
  ],
  deepDiveProgression: [
    'BrandCategoryOverviewAndProgression',
    'BrandMagnetScoreAndProgression',
    'BrandAttributeMapAndProgression',
    'SegmentOfSegmentOverviewAndProgression',
    'BrandImageryMappingAndProgressionGraph', // NEW FOR PROGRESSION
  ],
  reportSegment: [
    'CategoryPersona',
    'SegmentDriversAnalysis',
    'DriversProgression',
    'DriversProgressionWithoutSentiments',
    'SegmentDriversOnlyAnalysisWithoutSentiments',
    'SearchDriversProgression',
    'SegmentDriversOnlyAnalysis',
    'Triangulation',
    'TriangulationComparisonViewOnly',
    'SegmentOfSegmentOverview',
    'DriversProgression3Level',
    'SearchDriversProgression3Level',
    'SegmentDriversOnlyAnalysis3Level',
    'DriversProgressionWithoutSentiments3Level',
    'SegmentDriversOnlyAnalysisWithoutSentiments3Level',
    'CampaignTriggers',
    'DriversAndSubBrands',
    'DriversWithoutSentimentsAndSubBrands',
    'DriversAndTriggers',
    'BrandCategoryOverviewAndProgression',
    'BrandMagnetScoreAndProgression',
    'BrandAttributeMapAndProgression',
    'SegmentOfSegmentOverviewAndProgression',
    'BrandImageryMappingAndProgressionGraph', // NEW FOR PROGRESSION
  ],
  deepDiveDriversAppendices: [
    'AppendicesSearchDrivers',
    'AppendicesDriversAndRatingImpacts',
    'AppendicesDriversAndTriggers',
    'AppendicesDriversAndSubBrands',
    'AppendicesDriversWithoutSentimentsAndSubBrands',
    'AppendicesDrivers',
    'AppendicesDriversWithoutSentiments',
    'AppendicesDriversAndTriggers',
    'AppendicesDriversMotivatorsDetractors',
    'AppendicesDriversAndSubBrandsMotivatorsDetractors',
    'AppendicesDriversAndTriggersMotivatorsDetractors',
    'AppendicesDriversAndRatingImpactsMotivatorsDetractors',
  ],
  deepDiveSegmentsAppendices: [
    // 'AppendicesBrandCategoryOverviewAndProgression', 'AppendicesBrandMagnetScoreAndProgression', 'AppendicesBrandAttributeMapAndProgression', 'AppendicesSegmentOfSegmentOverviewAndProgression', 'AppendicesBrandImageryMappingAndProgressionGraph', // NEW FOR PROGRESSION
    'AppendicesBrandImageryMappingGraph',
    'AppendicesBrandImageryMappingAndProgressionGraph',
    // 'AppendicesDriversProgression3Level', 'AppendicesSearchDriversProgression3Level', 'AppendicesSegmentDriversOnlyAnalysis3Level', 'AppendicesDriversProgressionWithoutSentiments3Level'
  ],
  deepDiveSegmentsProgression: [
    'ProgressionBrandCategoryOverviewAndProgression',
    'ProgressionBrandMagnetScoreAndProgression',
    'ProgressionBrandAttributeMapAndProgression',
    'ProgressionSegmentOfSegmentOverviewAndProgression',
    'ProgressionBrandImageryMappingAndProgressionGraph', // NEW FOR PROGRESSION
  ],
  segmentDrivers: [
    'SegmentDriversAnalysis',
    'DriversProgression',
    'SearchDriversProgression',
    'DriversProgressionWithoutSentiments',
    'SegmentDriversOnlyAnalysisWithoutSentiments',
    'SegmentDriversOnlyAnalysisWithoutSentiments3Level',
    'Triangulation',
    'TriangulationComparisonViewOnly',
    'SegmentDriversOnlyAnalysis',
    'SegmentDriversOnlyAnalysis3Level',
    'DriversProgression3Level_v1',
    'DriversProgressionWithoutSentiments3Level_v1',
    'SearchDriversProgression3Level_v1',
  ]
}

export const SENTIMENTS = [
  {
    label: '',
    value: '',
  },
  {
    label: 'Negative',
    value: 'Negative',
  },
  {
    label: 'Positive',
    value: 'Positive',
  },
  {
    label: 'Mixed',
    value: 'Mixed',
  },
  {
    label: 'Neutral',
    value: 'Neutral',
  },
]

export const VISIVILITY = [
  {
    label: '',
    value: '',
  },
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Visible',
    value: 'Visible',
  },
  {
    label: 'Invisible',
    value: 'Invisible',
  },
]

export const MEDIA = {
  // xs: '600px',
  // sm: '980px',
  // md: '1000px',
  lg: '1200px',
  lg2: '1300px',
  xl: '1500px',
  // xxl: '1920px'
}

// ${MEDIA.lg}

export const CUSTOM_IMG_SEGMENT_COLOR = ['#C5A443', '#006400', '#ED7D31', '#646464', '#4472C4']

// For the screen width is below 1366px and 1280px
// export const IS_SCREEN_BELOW_1366 = () => window.innerWidth < 1000;
export const IS_SCREEN_BELOW_1366 = () => window.innerWidth < 1300;

// export const IS_SCREEN_BELOW_1180 = () => window.innerWidth < 1300;
export const IS_SCREEN_BELOW_1180 = () => window.innerWidth < 1180; 

export const thinScrollbar = css`
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(173, 173, 173, 1);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
`;